import React from 'react';
import PropTypes from 'prop-types';
import './modalTextWithHeader.less';

const ModalTextWithHeader = (props) => {
    return (
        <div className="modal-text-div">
            <h2 className="modal-header-text">
                {props.headerText}
            </h2>
            <br/>
            <p className="modal-content-text">
                {props.contentText}
            </p>
        </div>
    );
};

ModalTextWithHeader.propTypes = {
    headerText: PropTypes.string,
    contentText: PropTypes.string
}
export default ModalTextWithHeader;


// WEBPACK FOOTER //
// ./src/react/views/generic/ModalTextWithHeader.jsx